'use strict';

angular.module('ClinicApp').directive('userPrimeInvoiceReports', ($timeout, CurrentUser, UserService, OCPeriodMapUtil, $window, ClinicConfig) => {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_user-prime-invoice-reports.html',
    scope: {
      preloadData: '=',
    },
    link: ($scope) => {
      $scope.clinics = CurrentUser.getClinics();
      $scope.currentUser = CurrentUser.getUser();
      $scope.userSelected = {
        clinic: $scope.clinics
          .find((clinic) => String(clinic.id) === String($scope.preloadData.clinicId)) || $scope.clinics[0],
        period: {
          year: $scope.preloadData.year || null,
          month: $scope.preloadData.month || null,
        },
      };
      $scope.billableYears = [];
      $scope.billableMonthsByYear = {};
      $scope.billingPolicyUrl = `${ClinicConfig.SEARCH_APP_URL}/billing/`;

      $scope.updateUserSelected = () => {
        onUpdateUserSelected();
      };

      $scope.print = () => {
        $window.print();
      };

      function onUpdateUserSelected() {
        if ($scope.loading) {
          return;
        }

        $scope.loading = true;
        $scope.invoiceReport = null;
        $scope.userSelected = $scope.userSelected || {};
        $scope.userSelected.period = $scope.userSelected.period || {};

        return OCPeriodMapUtil.updateScopeWithPeriodMap($scope, 'invoiceReport', [$scope.userSelected.clinic.id]).then(() => {
          if (!$scope.userSelected.period.year || !$scope.userSelected.period.month) {
            $scope.loading = false;
            return;
          }

          return UserService.getClinicInvoiceReport(
            $scope.userSelected.clinic.id,
            $scope.userSelected.period.year,
            $scope.userSelected.period.month,
          ).then((invoiceReport) => {
            $scope.invoiceReport = invoiceReport;
            $scope.invoiceReport.paymentMethodsDisplay = $scope.invoiceReport.paymentMethods
              .map((paymentMethod) => `${paymentMethod.brand} •••• ${paymentMethod.last4}`)
              .join(', ');

            const billingPeriod = [
              $scope.userSelected.period.year,
              _.padLeft($scope.userSelected.period.month, 2, '0'),
              '01',
            ].join('-');

            OpencareAnalytics.trackPageView({
              pageType: OpencareAnalytics.pageTypes.INVOICE_MANAGER,
              pageName: `${$scope.currentUser.firstName} ${$scope.currentUser.lastName} Invoice Manager`,
              section: 'invoice',
              name: 'invoice-manager',
              content: {
                clinic: String($scope.userSelected.clinic.id),
                'billing-period': billingPeriod,
                view: 'practice',
                is_real_practice: String(!CurrentUser.isImpersonated()),
              },
              userId: $scope.currentUser.id,
            });
          });
        })
          .finally(() => {
            $scope.loading = false;
          });
      }

      $timeout(() => {
        onUpdateUserSelected();
      });
    },
  };
});
